import { rem } from 'polished';
import styled from 'styled-components';
import { mediaQueryWidth } from '../../common/breakpoints';
import { black, darkGrey2, white } from '../../common/colors';
import { sidePaddingStyles } from '../../common/padding.styles';

export const StyledRowHeaderTwo = styled.header<{ background?: string; color?: string }>`
  ${sidePaddingStyles}
  padding-top: ${rem(32)};
  padding-bottom: calc(${rem(32)} - 30px);
  background: ${({ background }) => background || white};
  color: ${({ color }) => color || black};

  @media (max-width: 768px) {
    padding-top: ${rem(24)};
    padding-bottom: calc(${rem(48)} - 30px);
  }
`;

export const StyledHeadingTwo = styled.div`
  margin: 0;
  font-size: ${rem(16)};
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
  color: ${({ color }) => color || darkGrey2};

  ${mediaQueryWidth({ min: 'tablet' })`
    font-size: ${rem(24)};
  `};

  & > span {
    font-weight: 300;
  }
`;
